const smartSchool = {
  // Header
  header: {
    title: 'نظام المدرسة الذكية',
    backToWebsite: 'الموقع الرئيسي',
    admin: 'المسؤول',
    systemAdmin: 'مدير النظام',
    logout: 'تسجيل الخروج',
  },

  // Sidebar
  sidebar: {
    logo: 'كلية ساي',
  },

  // Menu Items
  menu: {
    dashboard: 'لوحة التحكم',

    studentInfo: {
      title: 'معلومات الطلاب',
      details: 'تفاصيل الطلاب',
      admission: 'قبول الطلاب',
      onlineAdmission: 'القبول الإلكتروني',
      disabled: 'الطلاب ذوي الإعاقة',
      multiClass: 'طلاب متعددي الصفوف',
      bulkDelete: 'حذف جماعي',
      categories: 'فئات الطلاب',
      house: 'المجموعات الطلابية',
      disableReason: 'أسباب التعطيل',
      cv: 'السيرة الذاتية للطالب',
      studentDetails: 'تفاصيل الطلاب',
      manageStudentProfiles: 'إدارة ملفات الطلاب',
      studentProfile: 'ملف الطالب',
      personalInfo: 'المعلومات الشخصية',
      contactInfo: 'معلومات الاتصال',
      guardianInfo: 'معلومات ولي الأمر',
      academicInfo: 'المعلومات الأكاديمية',
    },

    fees: {
      title: 'النظام المالي',
      collection: 'تحصيل الرسوم',
      feeTypes: 'أنواع الرسوم',
      income: 'الإيرادات',
      expenses: 'المصروفات',
      reports: 'التقارير المالية',
    },

    onlineCourse: 'الدورات الإلكترونية',
    behaviourRecords: 'سجلات السلوك',
    multiBranch: 'الفروع المتعددة',

    liveClasses: {
      title: 'الفصول المباشرة',
      gmeet: 'Google Meet',
      zoom: 'Zoom',
    },

    academics: {
      title: 'الأكاديميات',
      classes: 'الصفوف والشعب',
      subjects: 'المواد الدراسية',
      timetable: 'الجدول الدراسي',
      lessonPlan: 'خطط الدروس',
      calendar: 'التقويم الأكاديمي',
      homework: 'الواجبات المنزلية',
    },

    examinations: {
      title: 'الامتحانات',
      regular: 'الامتحانات العادية',
      cbse: 'امتحانات CBSE',
      online: 'الامتحانات الإلكترونية',
    },

    attendance: 'الحضور والغياب',

    hr: {
      title: 'الموارد البشرية',
      employees: 'الموظفين',
      departments: 'الأقسام',
      leave: 'إدارة الإجازات',
      payroll: 'الرواتب',
      attendance: 'حضور الموظفين',
    },

    communicate: {
      title: 'التواصل',
      notice: 'لوحة الإعلانات',
      email: 'البريد الإلكتروني',
      sms: 'الرسائل النصية',
    },

    resources: {
      title: 'الموارد',
      downloadCenter: 'مركز التحميل',
      library: 'المكتبة',
      inventory: 'المخزون',
    },

    transport: 'النقل',
    hostel: 'السكن الطلابي',
    certificate: 'الشهادات',
    frontCMS: 'إدارة الموقع',
    alumni: 'الخريجين',
    reports: 'التقارير',

    system: {
      title: 'إعدادات النظام',
      settings: 'الإعدادات العامة',
      backup: 'النسخ الاحتياطي',
      roles: 'الأدوار والصلاحيات',
    },
  },

  // Dashboard
  dashboard: {
    title: 'لوحة التحكم الرئيسية',
    subtitle: 'نظرة شاملة على النظام المدرسي الذكي',

    stats: {
      totalStudents: 'إجمالي الطلاب',
      activeStudents: 'الطلاب النشطون',
      newAdmissions: 'قبول جديد',
      totalStaff: 'إجمالي الموظفين',
      teachers: 'المعلمون',
      adminStaff: 'الإداريون',
      totalRevenue: 'إجمالي الإيرادات',
      pendingFees: 'رسوم معلقة',
      collectionRate: 'معدل التحصيل',
      attendanceRate: 'معدل الحضور',
      todayPresent: 'حاضر اليوم',
      todayAbsent: 'غائب اليوم',
      upcomingExams: 'امتحانات قادمة',
      completedExams: 'امتحانات مكتملة',
      avgScore: 'متوسط الدرجات',
      totalClasses: 'إجمالي الصفوف',
      activeCourses: 'دورات نشطة',
      totalSubjects: 'إجمالي المواد',
    },

    quickAccess: {
      title: 'الوصول السريع',
      studentAdmission: 'قبول طالب جديد',
      markAttendance: 'تسجيل الحضور',
      collectFees: 'تحصيل الرسوم',
      createExam: 'إنشاء امتحان',
      assignHomework: 'تعيين واجب',
      sendNotice: 'إرسال إعلان',
      generateReport: 'إنشاء تقرير',
      manageLibrary: 'إدارة المكتبة',
    },

    recentActivities: {
      title: 'الأنشطة الأخيرة',
      newStudent: 'تسجيل طالب جديد',
      feePayment: 'دفع رسوم دراسية',
      examCreated: 'إنشاء امتحان جديد',
      homeworkAssigned: 'تعيين واجب منزلي',
      leaveApproved: 'الموافقة على إجازة',
      noticePublished: 'نشر إعلان جديد',
      bookIssued: 'إصدار كتاب من المكتبة',
      certificateGenerated: 'إنشاء شهادة',
    },

    upcomingEvents: {
      title: 'الفعاليات القادمة',
      parentMeeting: 'اجتماع أولياء الأمور',
      sportsDay: 'يوم رياضي',
      examWeek: 'أسبوع الامتحانات',
      holiday: 'عطلة',
      workshop: 'ورشة عمل',
    },

    charts: {
      studentGrowth: 'نمو الطلاب',
      feeCollection: 'تحصيل الرسوم',
      attendanceTrend: 'اتجاه الحضور',
      examPerformance: 'أداء الامتحانات',
    },
  },

  // Common
  common: {
    search: 'بحث',
    allClasses: 'جميع الصفوف',
    allStatus: 'جميع الحالات',
    active: 'نشط',
    inactive: 'غير نشط',
    graduated: 'متخرج',
    transferred: 'منقول',
    addNew: 'إضافة جديد',
    totalStudents: 'إجمالي الطلاب',
    newThisMonth: 'جديد هذا الشهر',
    photo: 'الصورة',
    admissionNo: 'رقم القبول',
    studentName: 'اسم الطالب',
    class: 'الصف',
    rollNo: 'رقم القيد',
    guardian: 'ولي الأمر',
    phone: 'الهاتف',
    status: 'الحالة',
    actions: 'الإجراءات',
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    close: 'إغلاق',
    confirmDelete: 'تأكيد الحذف',
    deleteWarning: 'هل أنت متأكد من حذف هذا السجل؟ لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    email: 'البريد الإلكتروني',
    dateOfBirth: 'تاريخ الميلاد',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    bloodGroup: 'فصيلة الدم',
    religion: 'الدين',
    address: 'العنوان',
    guardianName: 'اسم ولي الأمر',
    guardianPhone: 'هاتف ولي الأمر',
    guardianEmail: 'بريد ولي الأمر',
    relation: 'صلة القرابة',
    admissionDate: 'تاريخ القبول',
    category: 'الفئة',
    house: 'المجموعة',
  },

  // Common Actions
  actions: {
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    print: 'طباعة',
    view: 'عرض',
    download: 'تحميل',
    upload: 'رفع',
    submit: 'إرسال',
    approve: 'موافقة',
    reject: 'رفض',
    reset: 'إعادة تعيين',
    refresh: 'تحديث',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    close: 'إغلاق',
    confirm: 'تأكيد',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء التحديد',
    bulkAction: 'إجراء جماعي',
  },

  // Common Labels
  labels: {
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    date: 'التاريخ',
    time: 'الوقت',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    pending: 'معلق',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    completed: 'مكتمل',
    inProgress: 'قيد التنفيذ',
    description: 'الوصف',
    notes: 'ملاحظات',
    category: 'الفئة',
    type: 'النوع',
    amount: 'المبلغ',
    total: 'الإجمالي',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    tax: 'الضريبة',
    from: 'من',
    to: 'إلى',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    createdBy: 'أنشئ بواسطة',
    updatedBy: 'حُدث بواسطة',
  },

  // Messages
  messages: {
    success: 'تمت العملية بنجاح',
    error: 'حدث خطأ، يرجى المحاولة مرة أخرى',
    deleteConfirm: 'هل أنت متأكد من الحذف؟',
    noData: 'لا توجد بيانات',
    loading: 'جاري التحميل...',
    saving: 'جاري الحفظ...',
    processing: 'جاري المعالجة...',
    uploadSuccess: 'تم الرفع بنجاح',
    uploadError: 'فشل الرفع',
    invalidData: 'بيانات غير صحيحة',
    requiredField: 'هذا الحقل مطلوب',
    selectCriteria: 'اختر معايير البحث',
  },

  // Students
  students: {
    title: 'الطلاب',
    studentDetails: 'تفاصيل الطلاب',
    manageStudentProfiles: 'إدارة ملفات الطلاب',
    totalStudents: 'إجمالي الطلاب',
    activeStudents: 'الطلاب النشطون',
    graduatedStudents: 'الطلاب المتخرجون',
    newThisMonth: 'جديد هذا الشهر',
    admissionNo: 'رقم القبول',
    studentName: 'اسم الطالب',
    class: 'الصف',
    section: 'الشعبة',
    rollNo: 'رقم القيد',
    guardian: 'ولي الأمر',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    status: 'الحالة',
    photo: 'الصورة',
    viewDetails: 'عرض التفاصيل',
    studentProfile: 'ملف الطالب',
    personalInfo: 'المعلومات الشخصية',
    contactInfo: 'معلومات الاتصال',
    guardianInfo: 'معلومات ولي الأمر',
    academicInfo: 'المعلومات الأكاديمية',
    dateOfBirth: 'تاريخ الميلاد',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    bloodGroup: 'فصيلة الدم',
    religion: 'الدين',
    address: 'العنوان',
    guardianName: 'اسم ولي الأمر',
    guardianPhone: 'هاتف ولي الأمر',
    guardianEmail: 'بريد ولي الأمر',
    relation: 'صلة القرابة',
    admissionDate: 'تاريخ القبول',
    category: 'الفئة',
    house: 'المجموعة',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الطالب؟ لا يمكن التراجع عن هذا الإجراء.',
    allClasses: 'جميع الصفوف',
    allStatus: 'جميع الحالات',
    active: 'نشط',
    inactive: 'غير نشط',
    graduated: 'متخرج',
    transferred: 'منقول',
  },

  // Fees
  fees: {
    feeCollection: 'تحصيل الرسوم',
    manageFeeCollection: 'إدارة تحصيل الرسوم من الطلاب',
    totalCollected: 'إجمالي المحصل',
    totalPending: 'إجمالي المعلق',
    totalOverdue: 'إجمالي المتأخر',
    totalDiscount: 'إجمالي الخصومات',
    yemeniRial: 'ريال يمني',
    allClasses: 'جميع الصفوف',
    allStatus: 'جميع الحالات',
    paid: 'مدفوع',
    partial: 'مدفوع جزئياً',
    pending: 'معلق',
    overdue: 'متأخر',
    feeType: 'نوع الرسوم',
    amount: 'المبلغ',
    due: 'المستحق',
    dueDate: 'تاريخ الاستحقاق',
    recordPayment: 'تسجيل دفعة',
    viewReceipt: 'عرض الإيصال',
    feeTypes: 'أنواع الرسوم',
    manageFeeTypes: 'إدارة أنواع الرسوم الدراسية',
    addFeeType: 'إضافة نوع رسوم',
    code: 'الرمز',
    feeName: 'اسم الرسوم',
    feeGroup: 'مجموعة الرسوم',
    description: 'الوصف',
    allGroups: 'جميع المجموعات',
    active: 'نشط',
    inactive: 'غير نشط',
    deleteFeeTypeConfirm: 'هل أنت متأكد من حذف نوع الرسوم هذا؟',
  },

  // Income
  income: {
    title: 'الإيرادات',
    manageIncome: 'إدارة سجلات الإيرادات',
    totalIncome: 'إجمالي الإيرادات',
    totalRecords: 'إجمالي السجلات',
    averageIncome: 'متوسط الإيرادات',
    records: 'سجل',
    incomeRecords: 'سجلات الإيرادات',
    addIncome: 'إضافة إيراد',
    date: 'التاريخ',
    invoiceNo: 'رقم الفاتورة',
    category: 'الفئة',
    description: 'الوصف',
    amount: 'المبلغ',
    paymentMethod: 'طريقة الدفع',
    receivedBy: 'استلمه',
    allCategories: 'جميع الفئات',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    deleteConfirm: 'هل أنت متأكد من حذف سجل الإيراد هذا؟',
  },

  // Expenses
  expenses: {
    title: 'المصروفات',
    manageExpenses: 'إدارة سجلات المصروفات',
    totalExpenses: 'إجمالي المصروفات',
    totalRecords: 'إجمالي السجلات',
    averageExpense: 'متوسط المصروفات',
    records: 'سجل',
    expenseRecords: 'سجلات المصروفات',
    addExpense: 'إضافة مصروف',
    date: 'التاريخ',
    invoiceNo: 'رقم الفاتورة',
    category: 'الفئة',
    description: 'الوصف',
    amount: 'المبلغ',
    paymentMethod: 'طريقة الدفع',
    paidTo: 'دُفع إلى',
    vendor: 'المورد',
    status: 'الحالة',
    pending: 'معلق',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    allCategories: 'جميع الفئات',
    allStatus: 'جميع الحالات',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    deleteConfirm: 'هل أنت متأكد من حذف سجل المصروف هذا؟',
    approveExpense: 'الموافقة على المصروف',
    rejectExpense: 'رفض المصروف',
  },

  // Financial Reports
  financialReports: {
    title: 'التقارير المالية',
    subtitle: 'تقارير مالية شاملة وتحليلات',
    revenueVsExpenses: 'الإيرادات مقابل المصروفات',
    profitLoss: 'الربح والخسارة',
    feeCollectionRate: 'معدل تحصيل الرسوم',
    outstandingFees: 'الرسوم المستحقة',
    totalRevenue: 'إجمالي الإيرادات',
    totalExpenses: 'إجمالي المصروفات',
    netProfit: 'صافي الربح',
    netLoss: 'صافي الخسارة',
    collectionRate: 'معدل التحصيل',
    outstanding: 'المستحق',
    monthlyRevenue: 'الإيرادات الشهرية',
    monthlyExpenses: 'المصروفات الشهرية',
    selectPeriod: 'اختر الفترة',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذا العام',
    lastYear: 'العام الماضي',
    custom: 'مخصص',
    generateReport: 'إنشاء تقرير',
    profitLossStatement: 'بيان الربح والخسارة',
    period: 'الفترة',
    revenue: 'الإيرادات',
    expenses: 'المصروفات',
    profit: 'الربح',
    loss: 'الخسارة',
  },
};

export default smartSchool;